import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { AppComponent } from './app.component';
import { AppMaterial } from './app-material.module';
import { AppRoutingModule } from './app-routing.module';
import { McqDashboardComponent, InstructionComponent, MoreInfoComponent, ResultComponent, ConfirmComponent,
  InvitationFormComponent, RegisterComponent, RegisterationComponent, ThanksComponent,
  NavigatorComponent } from './components';
import { HttpService } from './services/http/http.service';
import { LocalstorageService } from './services/localstorage/localstorage.service';
import { HttpClientModule } from '@angular/common/http';
import { StageComponent } from './components/MCQTest/stage/stage.component';
import { RegisterUserComponent } from './components/MCQTest/register-user/register-user.component';
import { InvalidUrlComponent } from './components/MCQTest/invalid-url/invalid-url.component';
import { TestInstructionsComponent } from './components/MCQTest/test-instructions/test-instructions.component';
import { PortalLinkComponent } from './components/portal-link/portal-link.component';
import { CongratulationComponent } from './components/MCQTest/congratulation/congratulation.component';
import { CongratulationSorryPageComponent } from './components/MCQTest/congratulation-sorry-page/congratulation-sorry-page.component';
import { CountdownModule } from 'ngx-countdown';
import { RedirectFromBridgelabzComponent } from './components/MCQTest/redirect-from-bridgelabz/redirect-from-bridgelabz.component';
import { CodingClubResultComponent } from './components/MCQTest/coding-club-result/coding-club-result.component';
import { ChartsModule } from 'ng2-charts';
import { RadarChartComponent } from './components/MCQTest/radar/radar';
import { InternalServerErrorComponent } from './components/MCQTest/internal-server-error/internal-server-error.component';
import { BteqRegisterUserComponent } from './components/MCQTest/bteq-register-user/bteq-register-user.component';
@NgModule({
  declarations: [
    CongratulationSorryPageComponent,
    AppComponent,
    McqDashboardComponent,
    RegisterComponent,
    InstructionComponent,
    MoreInfoComponent,
    ResultComponent,
    ConfirmComponent,
    InvitationFormComponent,
    RegisterationComponent,
    ThanksComponent,
    NavigatorComponent,
    StageComponent,
    RegisterUserComponent,
    InvalidUrlComponent,
    TestInstructionsComponent,
    CongratulationComponent,
    PortalLinkComponent,
    RedirectFromBridgelabzComponent,
    CodingClubResultComponent,
    RadarChartComponent,
    InternalServerErrorComponent,
    BteqRegisterUserComponent
  ],
  imports: [
    BrowserModule,
    AppMaterial,
    AppRoutingModule,
    FlexLayoutModule,
    HttpClientModule,
    Ng4LoadingSpinnerModule.forRoot(),
    CountdownModule,
    ChartsModule,

  ],
  providers: [HttpService, LocalstorageService],
  entryComponents: [InstructionComponent, MoreInfoComponent, ConfirmComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
